<template>
    <div id="register_main">
        <div class="fom w flex">
            <div class="title">
                找回密码
            </div>
            <div class="form_warp">
                <el-form ref="form" :rules="rules" :model="form" label-width="100px" label-position="left">
                    <el-form-item label="手机号码" prop="phone">
                        <div class="input_warp">
                            <el-input v-model="form.phone"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <div class="input_warp">
                            <el-input v-model="form.code"></el-input>
                            <el-button class="send_btn" @click="getCode">{{ reg_codeTips }}</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="设置密码" prop="password">
                        <div class="input_warp">
                            <el-input type="password" v-model="form.password"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="passConfirm">
                        <div class="input_warp">
                            <el-input type="password" v-model="form.passConfirm"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="registerBtn" @click="onSubmit">保存</el-button>
                    </el-form-item>
                    <div class="tips flex">
                        <span>还没有帐号？</span>
                        <el-link type="danger" @click="registerTo">去注册</el-link>
                    </div>
                </el-form>
            </div>

        </div>
    </div>
</template>
      
<script>
import graceChecker from '@/utils/graceChecker';
import { updateUser, verifyAcount, sendSms } from "@/api/user";
export default {
    name: 'Forgot',
    data() {
        const validPhone = (rule, value, callback) => {
            var reg = /^1[0-9]{10,10}$/;
            if (!reg.test(value)) {
                callback(new Error('手机号格式有误'))
            } else {
                callback()
            }
        }

        const validPwd = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'))
            } else if (value.length < 6) {
                callback(new Error('密码长度不可小于6位'))
            } else if (this.form.passConfirm && value + '' !== this.form.passConfirm + '') {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        }

        const validPwdCon = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'))
            } else if (value.length < 6) {
                callback(new Error('密码长度不可小于6位'))
            } else if (this.form.password && value + '' !== this.form.password + '') {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        }
        return {
            user: null,
            form: {
                phone: '',
                code: '',
                password: '',
                passConfirm: ''
            },
            reg_onCode: true,
            reg_codeTime: 60,
            reg_codeTips: "获取验证码",
            codeVal: '',
            rules: {
                phone: [{ required: true, trigger: 'blur', validator: validPhone }],
                code: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
                password: [{ required: true, trigger: 'blur', validator: validPwd }],
                passConfirm: [{ required: true, trigger: 'blur', validator: validPwdCon }],
            },
        };
    },
    computed: {},
    mounted() {
        console.log("============")
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (!this.user) {
                        this.$message.error('请先获取验证码');
                        return;
                    }
                    if (!this.codeVal) {
                        this.$message.error('请先获取验证码');
                        return;
                    }
                    if (this.codeVal + '' === this.form.code + '') {
                        updateUser({
                            id: this.user.id,
                            passWord: this.form.password
                        }).then((res) => {
                            if (res.errCode + '' === '0') {
                                this.$message.success('修改成功');
                                this.form = {
                                    phone: '',
                                    code: '',
                                    password: '',
                                    passConfirm: ''
                                };
                                this.$router.replace("/login");
                                // this.$store.dispatch('GetInfo');
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                    } else {
                        this.$message.error('验证码错误');
                        return;
                    }

                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        registerTo() {
            this.$router.push('register');
        },
        // 获取用户
        getUser() {
            verifyAcount({
                phone: this.form.phone
            }).then((res) => {
                if (res.errCode + '' === '0') {
                    this.user = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        /* 发送验证码 */
        getCode() {
            if (!this.reg_onCode) {
                return;
            }
            //定义表单规则
            let rule = [
                { name: 'phone', checkType: 'phoneno', errorMsg: '请输入正确的手机号' }
            ];
            let checkRes = graceChecker.check(this.form, rule);
            if (checkRes) {
                this.reg_onCode = false;
                this.reg_codeTime = 60;
                this.reg_codeTips = `${this.reg_codeTime}s`;
                this.codeVal = '';
                sendSms({
                    phone: this.form.phone
                }).then((res) => {
                    if (res.errCode + '' === '0') {
                        this.codeVal = res.data;
                        this.$message.success('验证码发送成功');
                        this.getUser();
                    } else {
                        this.reg_codeTips = "重新获取";
                        this.reg_onCode = true;
                        this.$message.error('发送失败');
                        return;
                    }
                    let codeCd = null;
                    if (codeCd != null) clearInterval(codeCd);
                    codeCd = setInterval(() => {
                        this.reg_codeTips = `${--this.reg_codeTime}s`;
                        if (this.reg_codeTime <= 0) {
                            this.reg_codeTips = "重新获取";
                            this.reg_onCode = true;
                            clearInterval(codeCd);
                        }
                    }, 1000);
                });
            } else {
                this.$message.error(graceChecker.error);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.fom {
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    padding-bottom: 500px;
}

.input_warp {
    width: 440px;
    text-align: left;

    .el-input {
        width: 300px;
        margin-right: 10px;
    }
}

.title {
    width: 100%;
    text-align: left;
    padding: 45px 0;
    font-size: 30px;
    color: #323232;
}

.el-select {
    width: 100%;
}

.registerBtn {
    width: 238px;
    height: 48px;
    background-color: #f34343;
    font-size: 16px;
    color: #ffffff;
    height: 48px;
    border-radius: 48px;
    margin-left: -200px;
}

.send_btn {
    width: 117px;
    height: 38px;
    line-height: 38px;
    background-color: #f34343;
    font-size: 16px;
    color: #ffffff;
    border-radius: 8px;
}

.registerBtn:hover {
    background-color: #f34343;
    font-size: 16px;
    color: #ffffff;
    height: 48px;
    border-radius: 48px;
}

.registerBtn:active {
    color: #f34343;
    border-color: #ffffff;
    color: #ffffff;
    outline: 0;
}

.registerBtn:focus,
.registerBtn:hover {
    color: #f34343;
    border-color: #ffffff;
    color: #ffffff;
    background-color: #f34343;
}

.tips {
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-left: -100px;

    .el-link {
        font-size: 14px;
    }
}

.form_warp {
    ::v-deep .el-form-item__label {
        width: 100px !important;
        font-size: 14px;
    }

    ::v-deep .el-form-item__content {
        margin-left: 100px !important;
    }

    ::v-deep .el-input__inner {
        height: 40px;
    }

    ::v-deep .el-form-item {
        margin-bottom: 20px;
    }

    ::v-deep .el-button {
        padding: 0;
    }
}


.send_btn:hover {
    background-color: #f34343;
    color: #ffffff;
}

.send_btn:active {
    color: #f34343;
    border-color: #ffffff;
    color: #ffffff;
    outline: 0;
}

.send_btn:focus,
.send_btn:hover {
    color: #f34343;
    border-color: #ffffff;
    color: #ffffff;
    background-color: #f34343;
}
</style>